import { ColorNeutralDarkGrey, FontWeightNormal, Spacing4 } from 'autogen/design-tokens/tokens';
import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { breakpoint } from 'variables';
import { Typography } from '../typography';
import RatingStars, { type RatingStarsProps } from './RatingStars';

const RatingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    & > :last-child {
        margin-left: ${Spacing4};
    }

    ${({ theme }) => theme.RatingContainer}
`;

const Count = styled(Typography.Body)`
    display: none;

    ${breakpoint.up(321)} {
        display: initial;
        color: ${ColorNeutralDarkGrey};
        font-weight: ${FontWeightNormal};
    }
`;

export type RatingModuleProps = {
    averageRating: RatingStarsProps['rating'];
    size?: RatingStarsProps['size'];
    reviewCount: number;
    showRating?: boolean;
    showCount?: boolean;
    showAvgRatingCount?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export default function RatingModule({
    averageRating,
    size = 'S',
    reviewCount,
    showRating = true,
    showCount = true,
    showAvgRatingCount = true,
    ...restProps
}: RatingModuleProps) {
    if (!showRating) return null;

    return (
        <RatingContainer {...restProps}>
            <RatingStars rating={averageRating} size={size} />
            {showCount && (
                <Count
                    style={{
                        color: ColorNeutralDarkGrey,
                        fontWeight: FontWeightNormal
                    }}
                    size={size}
                >
                    {showAvgRatingCount && averageRating.toFixed(1)}
                    {` (${reviewCount})`}
                </Count>
            )}
        </RatingContainer>
    );
}
